import English_Canada from "./en-CA";
// import French_Canada from "./fr-CA";
import Simplified_Chinese from "./zh-CN";

export const languages = {
  "en-CA": English_Canada,
  // "fr-CA": French_Canada,
  "zh-CN": Simplified_Chinese
};
